<template>
  <div>
    <ValidationObserver ref="observer">
      <div class="mt-5 vx-row">
        <div class="vx-col w-full">
          <ul class="heading-ul mb-5">
            <li>
              <router-link
                :to="{ path: '/setup/collection-profile' }"
                class="vx-row"
              >
                <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
                <h4>{{ $t("setup.label.edit_collection_profile") }}</h4>
              </router-link>
            </li>
          </ul>
        </div>
        <vx-card title no-shadow card-border>
          <div class="vx-row">
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <vs-checkbox class="mt-5 mb-5 font-semibold" v-model="defaultValue">{{
                $t("setup.label.default")
              }}</vs-checkbox>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('setup.label.Name')"
              >
                <vs-input
                  :label="$t('setup.label.Name')"
                  class="w-full mb-2 font-semibold starlabel"
                  v-model="collectionName"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("setup.label.CustomerType") }}
                  <span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('setup.label.CustomerType')"
                >
                  <v-select
                    label="categoryType"
                    v-model="customerType"
                    :options="serviceTemplate.categoryDatas"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full mb-2"
                    :reduce="(categoryType) => categoryType.categoryType"
                  >
                    <template v-slot:option="option">{{
                      option.categoryType
                    }}</template>
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("setup.label.ServiceType") }}
                  <span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('setup.label.ServiceType')"
                >
                  <v-select
                    label="serviceCode"
                    v-model="serviceId"
                    :options="serviceTemplate.serviceDatas"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full mb-2"
                    :reduce="(categoryType) => categoryType.id"
                  >
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("setup.label.region") }}
                  <span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('setup.label.region')"
                >
                  <v-select
                    label="label"
                    v-model="regionCode"
                    :options="regionOptions"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full mb-2"
                  >
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <ValidationProvider
                rules=""
                v-slot="{ errors }"
                :name="$t('setup.label.jobTitle')"
              >
                <vs-input
                  :label="$t('setup.label.jobTitle')"
                  class="w-full mb-2 font-semibold"
                  v-model="jobTitle"
                />
                <span class="validate-error" style="color: red">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <ValidationProvider
                rules=""
                v-slot="{ errors }"
                :name="$t('setup.label.creditScore')"
              >
                <vs-input
                  :label="$t('setup.label.creditScore')"
                  class="w-full mb-2 font-semibold"
                  v-model="creditScore"
                />
                <span class="validate-error" style="color: red">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
        </vx-card>
      </div>
      <div class="vx-row center">
        <div class="vx-col w-full">
          <vs-button
            color="primary"
            type="border"
            class="mb-2 footerButton-cancel"
            @click="cancel"
            >{{ $t("setup.label.Cancel") }}</vs-button
          >
          <vs-button class="mr-3 mb-2 footerButton-next" @click="createTeam">{{
            $t("setup.label.Submit")
          }}</vs-button>
        </div>
      </div>
    </ValidationObserver>
    <validation-popup
      :errorMessage="errorMessage"
      :warningPopup="warningPopup"
      :warningText="warningText"
      @closeWarning="warningPopup = false"
    ></validation-popup>
  </div>
</template>
<script>
import vSelect from "vue-select";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapState } from "vuex";

export default {
  data() {
    return {
      networkEleData: {},
      profileId: "",
      collectionName: "",
      customerType: "",
      serviceId: "",
      regionCode: "",
      defaultValue: false,
      jobTitle: "",
      creditScore: "",
      systemById: {},
      regionOptions: [
        'Default'
      ],
      errorMessage: "",
      warningPopup: false,
      warningText: "",
    };
  },
  components: {
    "v-select": vSelect,
    ValidationProvider,
    ValidationObserver,
  },

  computed: {
    ...mapState({
      createTemplate: (state) => state.collectionProfile.createTemplate,
      serviceTemplate: (state) => state.collectionProfile.serviceTemplate,
      collection: (state) => state.collectionProfile.collection,
    }),
  },
  methods: {
    async getClientsTemplate() {
      try {
        await this.$store.dispatch(
          "collectionProfile/fetchCollectionTemplateService"
        );
        await this.$store.dispatch(
          "collectionProfile/fetchCollectionById",
          this.$route.params.id
        );
        this.collectionName = this.collection.collectionName;
        this.regionCode = this.collection.regionCode;
        this.serviceId = this.collection.serviceId;
        this.customerType = this.collection.customerType;
        this.defaultValue = this.collection.defaultFlag;
        this.jobTitle = this.collection.jobTitle;
        this.creditScore = this.collection.creditScore;
      } catch (e) {
        this.$toasted.error(e.message);
      }
    },
    async createTeam() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;
      let payload = {
        collectionName: this.collectionName,
        customerType: this.customerType,
        serviceId: this.serviceId,
        regionCode: this.regionCode,
        defaultFlag: this.defaultValue,
        jobTitle: this.jobTitle,
        creditScore: this.creditScore,
        locale: "en"
      };
      try{
      await this.$store.dispatch("collectionProfile/editCollectionAction", {
        id: this.$route.params.id,
        data: payload,
      });
      this.$swal({
        title: "Success",
        icon: "success",
        text: "Collection Profile Edited Successfully!",
        type: "success",
      });
      this.$router.push({ path: "/setup/collection-profile" });
      } catch (error) {
        const errorMessage = String(error).replace(/^Error:\s*/, "");
        this.$swal({
          title: "Error",
          icon: "error",
          html: `<div style="text-align: center;">${errorMessage}</div>`,
          type: "error",
        });
      }
    },
    cancel() {
      this.$router.push({ path: "/setup/collection-profile" });
    },
  },

  mounted() {
    this.getClientsTemplate();
  },
};
</script>
